import { render, staticRenderFns } from "./IconRound.vue?vue&type=template&id=5cfa6074&scoped=true"
import script from "./IconRound.vue?vue&type=script&lang=js"
export * from "./IconRound.vue?vue&type=script&lang=js"
import style0 from "./IconRound.vue?vue&type=style&index=0&id=5cfa6074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa6074",
  null
  
)

export default component.exports